import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [castes, setCastes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({ id: 0, name: "", casteID: "" });
  const [isEdit, setIsEdit] = useState(false);

  const apiUrl = `${baseUrl}/api/CategoryMaster`;

  useEffect(() => {
    fetchCategories();
    fetchCastes();
  }, []);

  const fetchCastes = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/CasteMaster`);
      setCastes(response.data);
    } catch (error) {
      toast.error("Failed to fetch Caste details");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(apiUrl);
      setCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch categories");
    }
  };

  const handleShowModal = (category = { id: 0, name: "", casteID: "" }) => {
    setCurrentCategory({
      id: category.id || 0,
      name: category.name || "",
      casteID: category.casteID || "",
    });
    setIsEdit(!!category.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentCategory({ id: 0, name: "", casteID: "", casteID: "" });
  };

  const handleChange = (e) => {
    setCurrentCategory({ ...currentCategory, name: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (isEdit) {
        await axios.put(`${apiUrl}/${currentCategory.id}`, currentCategory);
        toast.success("Category updated successfully");
      } else {
        await axios.post(apiUrl, currentCategory);
        toast.success("Category added successfully");
      }
      fetchCategories();
      handleCloseModal();
    } catch (error) {
      if (error?.response?.data) {
        toast.error(error?.response?.data);
      }
      else
      {
        toast.error("Failed to save category");
      }
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`${apiUrl}/${id}`);
        toast.success("Category deleted successfully");
        fetchCategories();
      } catch (error) {
        toast.error("Failed to delete category");
      }
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Manage Categories</h3>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Category
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Caste</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories
            .sort((a,b) => a.name.localeCompare(b.name))
            .map((category, index) => (
              <tr key={category.id}>
                <td>{index + 1}</td>
                <td>{category.name}</td>
                <td>{castes.find((c) => c.id === category.casteID)?.name}</td>
                <td>
                  <Button
                    variant="warning"
                    onClick={() => handleShowModal(category)}
                    className="me-2"
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => handleDelete(category.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Category" : "Add Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Caste</Form.Label>
              <Form.Control
                as="select"
                value={currentCategory.casteID}
                onChange={(e) => setCurrentCategory({ ...currentCategory, casteID: e.target.value })}
              >
                <option value="">Select Caste</option>
                {castes.map((caste) => (
                  <option key={caste.id} value={caste.id}>
                    {caste.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                value={currentCategory.name}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            {isEdit ? "Update" : "Add"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>

        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default Category;
